var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetskope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6572_132973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8183 7.32422C4.72397 7.53585 4.58248 7.74748 4.39383 7.93559C3.96937 8.33534 3.45058 8.49994 2.9082 8.52345L4.93621 10.4987C4.95979 9.98134 5.12486 9.46403 5.54932 9.06428C5.73797 8.87617 5.95021 8.7586 6.18602 8.64102C5.54932 8.42939 5.05411 7.93559 4.8183 7.32422Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3703 11.7919C5.14849 11.0395 5.14849 9.81673 4.3703 9.08778C3.59211 8.33532 2.3423 8.33532 1.56411 9.08778C0.785922 9.84024 0.785922 11.063 1.56411 11.7919C2.3423 12.5444 3.59211 12.5444 4.3703 11.7919Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38006 5.20692C9.15825 5.95938 9.15825 7.18213 8.38006 7.91108C7.60188 8.66354 6.35206 8.66354 5.57387 7.91108C4.79569 7.15862 4.79569 5.93587 5.57387 5.20692C6.35206 4.45446 7.62546 4.45446 8.38006 5.20692Z",
    fill: "#53565A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3974 5.20692C15.6192 4.45446 14.3693 4.45446 13.5912 5.20692C13.2139 5.58315 13.0252 6.02993 13.0252 6.50021C13.0016 7.01753 12.8366 7.53485 12.4121 7.93459C12.2234 8.12271 12.0112 8.26379 11.7754 8.35785C12.4121 8.56948 12.9073 9.06328 13.1431 9.67465C13.2374 9.46303 13.3789 9.2514 13.5676 9.06328C13.992 8.66354 14.5108 8.49894 15.0532 8.47542C15.5484 8.47542 16.02 8.26379 16.3974 7.91108C17.1755 7.15862 17.1755 5.95938 16.3974 5.20692ZM15.7135 7.25267C15.5248 7.44079 15.2654 7.53485 15.006 7.53485C14.7231 7.53485 14.4873 7.44079 14.2986 7.25267C13.8977 6.87644 13.8977 6.24156 14.2986 5.86533C14.4873 5.67721 14.7467 5.58315 15.006 5.58315C15.289 5.58315 15.5248 5.67721 15.7135 5.86533C15.9021 6.05344 15.9965 6.28858 15.9965 6.54724C16.02 6.82942 15.9257 7.06456 15.7135 7.25267Z",
    fill: "#00A7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3879 9.08778C13.1661 9.84024 13.1661 11.063 12.3879 11.7919C11.6097 12.5444 10.3599 12.5444 9.58169 11.7919C8.8035 11.0395 8.8035 9.81673 9.58169 9.08778C10.3599 8.33532 11.6333 8.33532 12.3879 9.08778Z",
    fill: "#53565A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58267 7.93438C9.15821 7.53463 8.99313 7.01732 8.96955 6.5L6.91797 8.47521C7.46034 8.49872 7.97913 8.66332 8.4036 9.06307C8.82806 9.46281 8.99313 9.98013 9.01672 10.4974L11.0447 8.52224C10.5259 8.49872 9.98356 8.33412 9.58267 7.93438Z",
    fill: "#53565A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6572_132973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetskope);
export default __webpack_public_path__ + "static/media/Netskope.e346a7f10a532eed29a09c2979ea55da.svg";
export { ForwardRef as ReactComponent };